export const getPathFromBreadcrumb = <T>(
  path: T[],
  segmentIndex: number,
  pathOffset = 0
): T[] | null => {
  if (segmentIndex < 0) return null;

  const sliceEnd = segmentIndex + 1 + pathOffset;
  if (sliceEnd <= 0 || sliceEnd > path.length) return null;

  return path.slice(0, sliceEnd);
};
